import React, { useState } from "react";
import NCALayerService from "../../services/NCALayerService/NCALayerService";
import SDKUserFormService from "../../services/SDKUserFormService";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ErrorModal from "../../component/ErrorModal";
import NCALayerModuleService from "../../services/NCALayerModuleService";
import SDKUserForm from "../SDK/SDKUserForm";


const NMUserForm = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { validatedBIN } = location.state;
  const { validatedOrganizationName } = location.state;
  const { validatedIIN } = location.state;
  const [bin, setBin] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [informationSystemName, setInformationSystemName] = useState("");
  const [iin, setIin] = useState("");
  const [personalPhoneNumber, setPersonalPhoneNumber] = useState("+7");
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
  const [isInputFocusedPhoneNumber, setIsInputFocusedPhoneNumber] =
    useState(false);
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isInputFocusedEmail, setIsInputFocusedEmail] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [moduleName, setModuleName] = useState("");
  const [moduleVersion, setModuleVersion] = useState("");
  const [isValidVersion, setIsValidVersion] = useState(false);
  const [isInputFocusedVersion, setIsInputFocusedVersion] = useState(false);
  const [moduleDescription, setModuleDescription] = useState("");
  const [moduleCheckSum, setModuleCheckSum] = useState("");
  const [implExternalFuncList, setImplExternalFuncList] = useState("");
  const [moduleLocation, setModuleLocation] = useState("");
  const [moduleFile, setModuleFile] = useState(null); // Файл будет храниться как объект File
  const [isModuleIsolated, setIsModuleIsolated] = useState(false); // Значение будет true или false



  const xmlString = `<root>
    <bin>${validatedBIN || bin}</bin>
    <organizationName>${escapeXml(
      validatedOrganizationName || organizationName
    )}</organizationName>
    <informationSystemName>${escapeXml(
      informationSystemName
    )}</informationSystemName>
    <iin>${validatedIIN || iin}</iin>
    <personalPhoneNumber>${escapeXml(personalPhoneNumber)}</personalPhoneNumber>
    <email>${escapeXml(email)}</email>
    <moduleName>${escapeXml(moduleName)}</moduleName>
    <moduleVersion>${escapeXml(moduleVersion)}</moduleVersion>
    <moduleDescription>${escapeXml(moduleDescription)}</moduleDescription>
    <moduleCheckSum>${escapeXml(moduleCheckSum)}</moduleCheckSum>
    <moduleFunctions>${escapeXml(
      implExternalFuncList
    )}</moduleFunctions>
    <moduleURL>${escapeXml(moduleLocation)}</moduleURL>
    <isModuleIsolated>${isModuleIsolated}</isModuleIsolated>
</root>`;

  const navigate = useNavigate();
  function escapeXml(unsafe) {
    return unsafe.replace(/[&<>"']/g, function (match) {
      switch (match) {
        case "&":
          return "&amp;";
        case "<":
          return "&lt;";
        case ">":
          return "&gt;";
        case '"':
          return "&quot;";
        case "'":
          return "&apos;";
        default:
          return match;
      }
    });
  }
  const handleSign = async (e) => {
    e.preventDefault();
    if (
      informationSystemName.trim() === "" ||
      !isValidPhoneNumber ||
      personalPhoneNumber === "+7" ||
      !isValidEmail ||
      email === ""
    ) {
      setErrorMessage("error.correctInputError");
      return;
    }
    try {
      const xmlResult = await NCALayerService.sign(
        xmlString,
        "1.3.6.1.5.5.7.3.4"
      );

      if (xmlResult === undefined) {
        navigate("/error", {
          replace: true,
          state: { error: t("error.ncalayer") },
        });
      } else {

        const formData = new FormData();
        formData.append('xmlData', xmlResult);

        await NCALayerModuleService.save(formData); // Убед
        navigate("/nm-success", { replace: true });
      }

      // navigate("/check-form/user-form/success");
    } catch (error) {
      console.error("Произошла ошибка:", error);
      // const errorMessage = error.response.data;
      // setErrorMessage(error.response.data.detail) /////оброботать на бэке исключений
      if (
        error.response &&
        error.response.status === 404 &&
        error.response.data.includes("foreign.key")
      ) {
        setErrorMessage("error.foreignKeyError");
        console.error("Используется чужая подпись");
      }else if (error.response && error.response.status === 404) {
        setErrorMessage("error.foreignKeyError");
        console.error("Используется чужая подпись");
      } else if (error.response && error.response.status === 500){
        setErrorMessage("error.revokedKeyError");
      }else {
        // Обработка других случаев ошибок
        console.error("Другая ошибка:", error.message);
        navigate("/error", { replace: true });
      }
    }
  };

  //////////////email////////////////////
  const validateEmail = (inputEmail) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(inputEmail);
    setIsValidEmail(isValid);
    return isValid;
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (isInputFocusedEmail) {
      validateEmail(newEmail);
    }
  };
  const handleInputFocus = () => {
    setIsInputFocusedEmail(true);
  };

  const handleInputBlur = () => {
    setIsInputFocusedEmail(false);
    validateEmail(email);
  };
  const handleChoiceChange = (event) => {
    setIsModuleIsolated(event.target.value === "yes");
  };

  // Обработчик выбора файла
  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setModuleFile(event.target.files[0]);
    }
  }; /////////////////////////////////////////////////////
  const validatePhoneNumber = (inputNumber) => {
    const phoneNumberRegex = /^(\+7|8)?\d{10}$/;
    const isValid = phoneNumberRegex.test(inputNumber);
    setIsValidPhoneNumber(isValid);
    return isValid;
  };

  const handlePersonalPhoneChange = (e) => {
    const inputValue = e.target.value;
    setPersonalPhoneNumber(inputValue);
    if (isInputFocusedPhoneNumber) {
      validatePhoneNumber(inputValue);
    }
  };

  const handleInputFocusPhoneNumber = () => {
    setIsInputFocusedPhoneNumber(true);
  };

  const handleInputBlurPhoneNumber = () => {
    setIsInputFocusedPhoneNumber(false);
    validatePhoneNumber(personalPhoneNumber);
  };
  ///////////////////////////////////////////////////

 // Функция для проверки версии модуля
const validateModuleVersion = (inputVersion) => {
  const versionRegex = /^[\d]+\.[\d]+(\.[\d]+)?$/; // 
  const isValid = versionRegex.test(inputVersion);
  setIsValidVersion(isValid); // Обновляем состояние валидности
  console.log("isValidVersion:", isValid); // Отладка
  return isValid;
};

// Обработчик изменений в поле версии
const handleVersionChange = (e) => {
  const inputValue = e.target.value;
  setModuleVersion(inputValue);
  console.log("moduleVersion (input):", inputValue); // Отладка

  // Немедленная проверка валидации
  validateModuleVersion(inputValue);
};

// Обработчик для фокуса на поле версии
const handleInputFocusVersion = () => {
  setIsInputFocusedVersion(true);
  console.log("Field focused"); // Отладка
};

// Обработчик для ухода из фокуса с поля версии
const handleInputBlurVersion = () => {
  setIsInputFocusedVersion(false);
  console.log("Field blurred"); // Отладка
};


  ///////////////////////////////////////////////////

  const formFields = [
    {
      id: "0",
      label: "SDKUserForm.bin",
      maxLength: 12,
      value: validatedBIN || bin,
      onChange: (e) => setBin(e.target.value),
      disabled: !!validatedBIN,
      placeholder: t("SDKUserForm.mandatoryPlaceholder"),
    },
    {
      id: "1",
      label: "SDKUserForm.organizationName",
      maxLength: 255,
      value: validatedOrganizationName || organizationName,
      onChange: (e) => setOrganizationName(e.target.value || validatedOrganizationName),
      disabled: !!validatedOrganizationName,
      placeholder: t(),
    },
    {
      id: "2",
      label: "SDKUserForm.informationSystem",
      maxLength: 255,
      value: informationSystemName,
      onChange: (e) => setInformationSystemName(e.target.value),
      placeholder: t("SDKUserForm.informSystemPlace"),
          className: "no-disable-field"
    },
    {
      id: "3",
      label: "SDKUserForm.iin",
      maxLength: 12,
      value: validatedIIN || iin,
      onChange: (e) => setIin(e.target.value || validatedIIN),
      disabled: !!validatedIIN,
      placeholder: t("SDKUserForm.mandatoryPlaceholder"),
    },
    {
      id: "4",
      label: "SDKUserForm.phoneNumber",
      maxLength: 12,
      value: personalPhoneNumber,
      onChange: handlePersonalPhoneChange,
      onFocus: handleInputFocusPhoneNumber,
      onBlur: handleInputBlurPhoneNumber,
      placeholder: "+7(_ _ _) _ _ _ - _ _ - _ _",
      pattern: /^(\+7|8)?\d{10}$/,
      errorMessage: !isValidPhoneNumber && !isInputFocusedPhoneNumber && (personalPhoneNumber.trim() !== "" || personalPhoneNumber === "+7") ? t("SDKUserForm.errorPhoneNumber") : null,
      className: "no-disable-field"
    },
    {
      id: "5",
      label: "SDKUserForm.email",
      maxLength: 255,
      value: email,
      onChange: handleEmailChange,
      onFocus: handleInputFocus,
      onBlur: handleInputBlur,
      placeholder: "example@example.kz",
      errorMessage: !isValidEmail && !isInputFocusedEmail && email.trim() !== "" ? t("SDKUserForm.errorEmail") : null,
      className: "no-disable-field"
    },
    // Новые поля для NCALayerModuleForm
    {
      id: "6",
      label: "NCALayerModuleForm.moduleName",
      maxLength: 255,
      value: moduleName,
      onChange: (e) => setModuleName(e.target.value),
      placeholder: t("SDKUserForm.moduleName"),
      className: "no-disable-field"
    },
    {
      id: "7",
      label: "NCALayerModuleForm.moduleVersion",
      maxLength: 255,
      value: moduleVersion,
      onChange: handleVersionChange,
      onFocus: handleInputFocusVersion,
      onBlur: handleInputBlurVersion,
      placeholder: "1.0.0",
      pattern: "/^[\d]+\\.[\d]+(\.[\d]+)?$/",
      errorMessage: !isValidVersion && !isInputFocusedVersion && moduleVersion.trim() !== "" 
                    ? t("NCALayerModuleForm.errorVersionModule") 
                    : null,
      className: "no-disable-field",
    },
    
    {
      id: "8",
      label: "NCALayerModuleForm.moduleDescription",
      maxLength: 255,
      value: moduleDescription,
      onChange: (e) => setModuleDescription(e.target.value),
      placeholder: t("SDKUserForm.desciptionPlaceholder"),
      className: "no-disable-field",
      isTextArea: true,
    },
    {
      id: "9",
      label: "NCALayerModuleForm.moduleFunctions",
      maxLength: 255,
      value: implExternalFuncList,
      onChange: (e) => setImplExternalFuncList(e.target.value),
      placeholder: t("SDKUserForm.functionList"),
      className: "no-disable-field",
      isTextArea: true,
    },
    {
      id: "10",
      label: "NCALayerModuleForm.moduleChecksum",
      maxLength: 255,
      value: moduleCheckSum,
      onChange: (e) => setModuleCheckSum(e.target.value),
      placeholder: t("SDKUserForm.moduleSum"),
      className: "no-disable-field"
    },
    {
      id: "11",
      label: "NCALayerModuleForm.moduleURL",
      maxLength: 255,
      value: moduleLocation,
      onChange: (e) => setModuleLocation(e.target.value),
      placeholder: "https://example.com/downloads/example.jar",
      className: "no-disable-field"
    }
  ];
//////////////

  const validateField = (value, type) => {
    const validations = {
        email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        phoneNumber: /^(\+7|8)?\d{10}$/,
        moduleName: /^[\w\s]{1,255}$/,
        moduleVersion: /^[\d]+\.[\d]+(\.[\d]+)?$/,
        // Добавьте другие типы по мере необходимости
    };
    return validations[type] ? validations[type].test(value) : true; // По умолчанию true для неопределенных типов
};

const handleInputChange = (e, type) => {
  const { value } = e.target;
  switch (type) {
      case 'bin':
          setBin(value);
          break;
      case 'organizationName':
          setOrganizationName(value);
          break;
      case 'moduleName':
          setModuleName(value);
          break;
      // Добавьте другие поля по мере необходимости
      default:
          break;
  }
  
  const isValid = validateField(value, type);
  // Установите состояние для ошибки, если нужно
  // setIsValidXXX(isValid);
};
// const formFields = [
//   { id: "0", label: "SDKUserForm.bin", type: "bin", ... },
//   { id: "1", label: "SDKUserForm.organizationName", type: "organizationName", ... },
//   { id: "2", label: "NCALayerModuleForm.moduleName", type: "moduleName", ... },
//   // Другие поля...
// ];

// {formFields.map((field) => (
//   <input
//       key={field.id}
//       type="text"
//       value={field.value}
//       onChange={(e) => handleInputChange(e, field.type)}
//       // Остальные свойства...
//   />
// ))}
/////////////////////////
  return (
    <div className="content">
      <div className="titleCell">
        <span>{t("NCALayerModuleForm.title")}</span>
      </div>

    
      <form id="indexForm" className="indexForm" >
        <div className="vktHeaderDiv">{t("SDKUserForm.formTitle")}</div>
        {errorMessage && <ErrorModal errorMessage={t(errorMessage)} />}
    
        

        <table style={{ width: "100%" }}>
          <tbody>
            
           
          {formFields.map((field) => (
  <tr key={field.id}>
    <td>
      <table cellPadding="8" style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td className="ccLeft width-255">
              <span id={`rcfield:${field.id}:labels`}>
                {t(field.label)}:
                <span style={{ color: "red" }}> *</span>
              </span>
            </td>
            <td className="ccRight width-525">
              <span id={`rcfield:${field.id}:values`}>
                {field.isTextArea ? (
                  <textarea
                    id={`rcfield:${field.id}:inputValue`}
                    name={`rcfield:${field.id}:inputValue`}
                    maxLength={field.maxLength}
                    className={`ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 bin ${field.className || ''} custom-textarea`}
                    placeholder={field.placeholder}
                    value={field.value}
                    onChange={field.onChange}
                    rows={4} // Adjust the number of rows as needed
                  />
                ) : (
                  <input
                    id={`rcfield:${field.id}:inputValue`}
                    name={`rcfield:${field.id}:inputValue`}
                    type="text"
                    maxLength={field.maxLength}
                    className={`ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all width-450 bin ${field.className || ''}`}
                    placeholder={field.placeholder}
                    value={field.value}
                    onChange={field.onChange}
                    onFocus={field.onFocus}
                    onBlur={field.onBlur}
                    pattern={field.pattern}
                    disabled={field.disabled}
                  />
                )}
              </span>
              {field.errorMessage && (
                <div className="error-message">
                  {field.errorMessage}
                </div>
              )}
            </td>
            <td className="ccRight">
              <span id={`rcfield:${field.id}:additionals`}></span>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
))}

           

            {/* Новое поле: прикрепить файл */}
            {/* <tr>
              <td>
                <table cellPadding="8" style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td className="ccLeft width-255">
                        <span id="rcfield:7:labels">
                          {t("NCALayerModuleForm.moduleFileAttachment")}:
                          <span style={{ color: "red" }}> *</span>
                        </span>
                      </td>
                      <td className="ccRight width-525">
                        <span id="rcfield:7:values">
                          <input
                            id="rcfield:7:inputValue"
                            name="rcfield:7:inputValue"
                            type="file"
                            className="file-input"
                            onChange={handleFileChange}
                            style={{  }} // Скрываем стандартное поле */}
                          {/* /> */}
                          {/* <button
                            type=""
                            className="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only new-blue-btn"
                            onClick={(event) =>{
                              // event.preventDefault();
                              document
                              .getElementById("rcfield:7:inputValue")
                              .click();
                            }
                            }
                          >
                            {t("NCALayerModuleForm.selectFile")}
                          </button> */}
                        {/* </span>
                      </td>
                      <td className="ccRight">
                        <span id="rcfield:7:additionals"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr> */}
          </tbody>
        </table>

        <span id="ncalayerCallBlock" className="tooltip-container">
  <button
    id="submitDataBTest"
    name="submitDataBTest"
    className="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only new-blue-btn w-100"
    onClick={handleSign}
    type="submit"
    role="button"
    aria-disabled="false"
  >
    <span className="tooltip_element">
      {t("SDKUserForm.signButton")}
    </span>
  </button>
  
  <div className="tooltip-text">
  <p>{t("SDKUserForm.moduleHint")}</p>
  <p>{t("SDKUserForm.moduleHintNext")}</p>
  </div>
</span>



          
          {/* <button
            id="submitOrderBTest"
            name="submitOrderBTest"
            className=""
            onClick={() => {}}
            style={{ display: "none" }}
            type="submit"
            role="button"
            aria-disabled="false"
          > */}
            {/* <span className="ui-button-text ui-c">ui-button</span>
          </button> */}
        
      </form>
    </div>
  );
};

export default NMUserForm;

